import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

const vuoto = { tipo: "privato", nome: "", cognome: "", codice_fiscale: "", partita_iva: "", email: "", telefono: "", indirizzo: "", citta: "", cap: "" };

/** Crea un cliente al volo senza uscire dal documento; restituisce il cliente creato a onCreato. */
export function NuovoClienteDialog({ open, onOpenChange, onCreato, testId = "nuovo-cliente" }) {
  const [f, setF] = useState(vuoto);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const azienda = f.tipo === "azienda";
  const salva = async (e) => {
    e.preventDefault(); e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post("/clienti", { ...f, cognome: azienda ? "" : f.cognome, note: "" });
      toast.success("Cliente creato"); setF(vuoto); onOpenChange(false); onCreato(data);
    } catch (err) { toast.error(err.response?.data?.detail || "Errore salvataggio"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid={`${testId}-dialog`} onClick={(e) => e.stopPropagation()}>
        <DialogHeader><DialogTitle>Nuovo cliente</DialogTitle><DialogDescription>Verrà selezionato subito come committente.</DialogDescription></DialogHeader>
        <form onSubmit={salva} className="space-y-3">
          <div className="flex gap-1 rounded-md bg-slate-100 p-0.5 w-fit text-xs">
            {["privato", "azienda"].map((t) => <button key={t} type="button" onClick={() => setF({ ...f, tipo: t })} className={`px-3 py-1 rounded capitalize ${f.tipo === t ? "bg-white shadow font-semibold" : "text-slate-500"}`} data-testid={`${testId}-tipo-${t}`}>{t}</button>)}
          </div>
          <div className="grid grid-cols-2 gap-3">
            {!azienda && <div className="space-y-1"><Label>Cognome</Label><Input value={f.cognome} onChange={set("cognome")} required autoFocus data-testid={`${testId}-cognome`} /></div>}
            <div className={`space-y-1 ${azienda ? "col-span-2" : ""}`}><Label>{azienda ? "Ragione sociale" : "Nome"}</Label><Input value={f.nome} onChange={set("nome")} required autoFocus={azienda} data-testid={`${testId}-nome`} /></div>
            <div className="space-y-1"><Label>Codice fiscale</Label><Input value={f.codice_fiscale} onChange={set("codice_fiscale")} className="font-mono uppercase" data-testid={`${testId}-cf`} /></div>
            <div className="space-y-1"><Label>Partita IVA</Label><Input value={f.partita_iva} onChange={set("partita_iva")} className="font-mono" data-testid={`${testId}-piva`} /></div>
            <div className="space-y-1"><Label>Email</Label><Input type="email" value={f.email} onChange={set("email")} data-testid={`${testId}-email`} /></div>
            <div className="space-y-1"><Label>Telefono</Label><Input value={f.telefono} onChange={set("telefono")} data-testid={`${testId}-telefono`} /></div>
            <div className="space-y-1 col-span-2"><Label>Indirizzo</Label><Input value={f.indirizzo} onChange={set("indirizzo")} data-testid={`${testId}-indirizzo`} /></div>
            <div className="space-y-1"><Label>Città</Label><Input value={f.citta} onChange={set("citta")} data-testid={`${testId}-citta`} /></div>
            <div className="space-y-1"><Label>CAP</Label><Input value={f.cap} onChange={set("cap")} data-testid={`${testId}-cap`} /></div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
            <Button type="submit" disabled={busy} data-testid={`${testId}-salva`}>{busy ? "Salvo…" : "Crea e seleziona"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
